import React from 'react';

import { HintLink } from '../../../../../../HintLink';

export const EmailLink: React.FC = ({ children }) => (
  <HintLink href="mailto:welcome@unitedtraders.com" rel="nofollow noopener" tabIndex={-1}>
    {children}
  </HintLink>
);
